export enum ColumnTitles {
  KEY = '#',
  LOCATION = 'Location',
  PRODUCT = 'Product',
  SKU = 'SKU',
  CATEGORY = 'Category',
  SUB_CATEGORY = 'Sub category',
  BRAND = 'Brand',
  QUANTITY = 'Quantity',
  UNIT_COST = 'Unit cost',
  UNIT_PRICE = 'Retail price',
  TOTAL_COST = 'Total cost',
  TOTAL_PRICE = 'Total value',
  MARGIN = 'Margin',
}

export enum ColumnKeys {
  KEY = 'key',
  LOCATION = 'locationName',
  PRODUCT = 'productName',
  SKU = 'productSKU',
  CATEGORY = 'parentCategoryName',
  SUB_CATEGORY = 'categoryName',
  BRAND = 'productVendorName',
  QUANTITY = 'inventoryQuantity',
  UNIT_COST = 'productCost',
  UNIT_PRICE = 'productPrice',
  TOTAL_COST = 'inventoryCost',
  TOTAL_PRICE = 'inventoryPrice',
  MARGIN = 'margin',
}

export enum CubeInventoryLogFields {
  ID = 'InventoryLog.id',
  NEW_VALUE = 'InventoryLog.newValue',
  COST = 'InventoryLog.cost',
  PRICE = 'InventoryLog.price',
  PRODUCT_COST = 'InventoryLog.productCost',
  MARGIN = 'InventoryLog.margin',
  MAX_ID = 'InventoryLog.maxId',
  TOTAL = 'InventoryLog.total',
  ENTITY_ID = 'InventoryLog.entityid',
  CREATE_DATE = 'InventoryLog.createdate',
}

export enum CubeMaxInventoryLogFields {
  MAX_ID = 'MaxInventoryLog.maxId',
  COMPANY_ID = 'MaxInventoryLog.companyId',
  ENTITY_ID = 'MaxInventoryLog.entityId',
  CREATE_DATE = 'MaxInventoryLog.createDate',
}
